import React from 'react';
import TeachersProfile from './teachersProfile';
import StudentsProfile from './studentsProfile';
import AdminsProfile from './adminsProfile';
import { RoleBasedRoute } from '../../components';
import SchoolPages from './authorizedPersonProfile';

const Profile = () => {
  return (
    <div>
      <RoleBasedRoute exact path="/profile/admin" roles={['admin']} component={AdminsProfile} />
      <RoleBasedRoute
        exact
        path="/profile/teacher"
        roles={['teacher']}
        component={TeachersProfile}
      />
      <RoleBasedRoute
        exact
        path="/profile/student"
        roles={['student']}
        component={StudentsProfile}
      />
      <RoleBasedRoute exact path="/profile/director" roles={['director', 'admin']} component={SchoolPages} />
    </div>
  );
};

export default Profile;
